import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'

import { isManuallyLoggedOut$, isUserAuthorized$ } from 'src/store/modules/auth'

const WithAuth = (Component: React.FC, oauth = false) => {
  const WithAuthWrapper = (props) => {
    const isUserAuthorized = useSelector(isUserAuthorized$)
    const isManuallyLoggedOut = useSelector(isManuallyLoggedOut$)
    const location = useLocation()

    if (isUserAuthorized) {
      return <Component {...props} />
    }

    return (
      <Redirect
        to={
          oauth
            ? {
                pathname: '/oauth/login',
                search: location.search
              }
            : {
                pathname: '/auth/login',
                state: isManuallyLoggedOut ? undefined : { referrer: location }
              }
        }
      />
    )
  }

  return WithAuthWrapper
}

export default WithAuth
